module.exports = __webpack_public_path__ + "img/ebook-exercise.e13056b8.svg";